import { createPatchEndpoint, HttpHeader } from '@sonar-software/sonar-http';

import { PackageTier } from '../@types/Customer';

export type PatchCustomerRequest = {
	customerId?: number;
	isLocked?: boolean;
	name?: string;
	salesforceAccountId?: string | null;
	timelineRetentionPeriod?: number | null;
	packageTier?: PackageTier | null;
	shardName?: string;
};

export const patchCustomer = createPatchEndpoint<PatchCustomerRequest, void>(
	(request) => `/api/v3/core/customers/${request?.customerId ?? 'current'}`,
	{
		headers: (request) => {
			if (request?.shardName) {
				return { [ HttpHeader.Shard ]: request.shardName };
			}

			return {};
		},
		requestTransform: (request) => ({
			isLocked: request.isLocked,
			name: request.name,
			salesforceAccountId: request.salesforceAccountId,
			timelineRetentionPeriod: request.timelineRetentionPeriod,
			packageTier: request.packageTier
		})
	}
);
